// Copyright ©️ 2026 eVolve MEP, LLC

import { type HexTriplet, FLAT_BLACK_FILLER } from '@evolvemep/api-ts';
import type { MantineColor, MantineThemeColors } from '@mantine/core';

import { isNil } from 'helpers/isNotNil';

/** Converts a MantineColor into HEX format */
export const convertMantineColorToHex = (value: MantineColor, themeColors: MantineThemeColors): HexTriplet => {
  const [color, shade = '6'] = value.split('.');
  if (isNil(color) || isNil(themeColors[color])) return FLAT_BLACK_FILLER;
  return themeColors[color][parseInt(shade)] as HexTriplet;
};
